import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IChannelRepository } from '../../repositories/interfaces/iChannelRepository';
import { IGetChannelScheduleParams, IGetChannelScheduleResponse } from '../../entities/iChannels';

export interface IGetChannelScheduleUseCase {
    execute(params: IGetChannelScheduleParams): Promise<IGetChannelScheduleResponse>;
}

export class GetChannelScheduleUseCase implements IGetChannelScheduleUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get channelsRepo(): IChannelRepository {
        return container.resolve<IChannelRepository>(DI.REPOSITORIES.IChannelRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(params: IGetChannelScheduleParams): Promise<IGetChannelScheduleResponse> {
        return await this.channelsRepo.getChannelSchedule(params);
    }
}
